import { Link, useLocation } from "react-router-dom";
import Header from "../../Layout/Header";
import Profilemenu from "./Profilemenu";
import "./MyBooking.css";
import { useEffect, useState } from "react";
import {
  canclebooking,
  getBookingTask,
  needhelp,
  upcomingbooking,
} from "../../service/Mainservice";
import { Alert, Snackbar } from "@mui/material";
import Needhelp from "./Needhelp";
import Canclebooking from "./Canclebooking";
import Loader from "../../Loader/Loader";
import Pagination from "../../Pagination/Pagination";
import moment from "moment";

const Upcomingbook = () => {
  const [list, setlist] = useState();
  const [load, setload] = useState(true);
  const [openTasks, setOpenTasks] = useState({});
  const [need, setneed] = useState(false);
  const [cancle, setcancle] = useState(false);
  const [bookid, setbookid] = useState();
  const [cid, setcid] = useState();
  const [success, setsuccess] = useState();
  const [open, setOpen] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState();

  const location = useLocation();
  const path = location.pathname;
  const closealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    getupcoming(1);
  }, []);

  const getupcoming = async (val = 1) => {
    try {
      const response = await upcomingbooking(val);
      console.log(response);
      const bookingList = response.data.data || [];
      const bookingWithTasks = await Promise.all(
        bookingList.map(async (booking) => {
          try {
            const taskResponse = await getBookingTask(booking.id);
            return {
              ...booking,
              tasks: taskResponse.data?.data || [],
            };
          } catch (error) {
            console.log(error);
            return {
              ...booking,
              tasks: [],
            };
          }
        }),
      );
      setlist(bookingWithTasks);
      setcurrentPage(response.data.pagination.current_pages);
      settotalPages(response.data.pagination.total_pages);
      setload(false);
    } catch (error) {
      console.log(error);
      setload(false);
    }
  };

  const handlecanclebooking = async (values, { resetForm }) => {
    try {
      const response = await canclebooking(values, cid);
      getupcoming();
      setcancle(false);
      setsuccess(response.data.message);
      setOpen(true);
      resetForm();
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };
  const handleneedhelp = async (values, { resetForm }) => {
    try {
      const response = await needhelp(values, bookid);
      getupcoming();
      setneed(false);
      setsuccess(response.data.message);
      setOpen(true);
      resetForm();
    } catch (error) {
      console.log(error);
    }
  };

  const handleneed = (id) => {
    setbookid(id);
    setneed(true);
  };
  const handlecancle = (id) => {
    setcid(id);
    setcancle(true);
  };
  const toggleTasks = (id) => {
    setOpenTasks((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const getCaregiverCountryCode = (data) =>
    data.caregiver_country_code || "N/A";

  const getCaregiverPhoneNumber = (data) =>
    data.caregiver_phone_number || "N/A";

  return (
    <>
      <Header title="My Booking" headerbg="upcomingbg" />
      <div className="editprofile_data">
        <Profilemenu />
        <div className="editprofile_info">
          <h2 className="editprofile_maintitle">My Booking</h2>
          <div className="booking_status">
            <Link
              to="/MybookingUpcoming"
              className={
                path === "/MybookingUpcoming"
                  ? "booking_status_title selected_title"
                  : "booking_status_title"
              }
            >
              Upcoming
            </Link>
            <Link
              to="/MybookingCompleted"
              className={
                path === "/MybookingCompleted"
                  ? "booking_status_title selected_title"
                  : "booking_status_title"
              }
            >
              Completed
            </Link>
          </div>
          {list ? (
            <div>
              <div className="mybooking_cardlist">
                {list.map((data) => (
                  <div className="mybooking_card modern_card">
                    <div className="mybooking_card_section">
                      <div className="section_title_div">
                        <p className="section_title">📄 Booking Info</p>
                        <p className="booking_type_badge">
                          {data.booking_type}
                        </p>
                      </div>
                      <div className="mybooking_card_row">
                        <div className="mybooking_cardinfo1">
                          <p>Request ID</p>
                          <h3>{data.request_id}</h3>
                        </div>
                        <div className="mybooking_cardinfo1">
                          <p>Booking Hr</p>
                          <h3>{data.booking_hours || "N/A"}</h3>
                        </div>
                        <div className="mybooking_cardinfo1">
                          <p>Start Date</p>
                          <h3>
                            {moment(data.start_booking_date).format("MM/DD/YY")}
                          </h3>
                        </div>
                        {data.booking_type === "OneTime" && (
                          <div className="mybooking_cardinfo1">
                            <p>End Date</p>
                            <h3>
                              {" "}
                              {moment(data.end_booking_date).format("MM/DD/YY")}
                            </h3>
                          </div>
                        )}
                      </div>
                      <div className="mybooking_card_row">
                        {data.booking_type === "Recurring" &&
                          data.recurring_days.length > 0 && (
                            <div className="mybooking_cardinfo1">
                              <p>Recurring Days</p>
                              <div className="mybooking_days_div">
                                {data.recurring_days.map((day) => (
                                  <h3 className="mybooking_days">
                                    {day.trim()}
                                  </h3>
                                ))}
                              </div>
                            </div>
                          )}
                        {data.booking_type === "Flexible" &&
                          data.flexible_dates?.length > 0 && (
                            <div className="mybooking_cardinfo1">
                              <p>Flexible Dates</p>
                              <div className="mybooking_days_div">
                                {data.flexible_dates.map((day) => (
                                  <h3 className="mybooking_days">
                                    {moment(day.trim()).format("MM/DD/YY")}
                                  </h3>
                                ))}
                              </div>{" "}
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="mybooking_card_section">
                      <div className="mybooking_card_row">
                        <div className="mybooking_cardinfo1">
                          <p>Time</p>
                          <h3>{data.booking_time}</h3>
                        </div>
                        <div className="mybooking_cardinfo1">
                          <p>Address</p>
                          <h3>{data.address}</h3>
                        </div>
                      </div>
                    </div>
                    <div className="mybooking_card_section mybooking_task_section">
                      <button
                        type="button"
                        className="mybooking_task_toggle"
                        onClick={() => toggleTasks(data.id)}
                      >
                        <div>
                          <p className="section_title mybooking_task_title">
                            Tasks
                          </p>
                          <p className="mybooking_task_count">
                            {data.tasks?.length || 0} task
                            {data.tasks?.length === 1 ? "" : "s"}
                          </p>
                        </div>
                        <span
                          className={`mybooking_task_arrow ${
                            openTasks[data.id] ? "open" : ""
                          }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-chevron-down-icon lucide-chevron-down"
                          >
                            <path d="m6 9 6 6 6-6" />
                          </svg>
                        </span>
                      </button>
                      {openTasks[data.id] &&
                        (data.tasks?.length > 0 ? (
                          <div className="mybooking_task_list">
                            {data.tasks.map((task) => (
                              <div
                                className="mybooking_task_item"
                                key={task.id}
                              >
                                <div className="mybooking_task_content">
                                  <h4>{task.task}</h4>
                                  <p>{task.task_time}</p>
                                </div>
                                <div className="mybooking_task_content2">
                                  <span
                                    className={`mybooking_task_status ${
                                      task.status === "completed"
                                        ? "completed"
                                        : "pending"
                                    }`}
                                  >
                                    {task.status}
                                  </span>
                                  <p>{task.date_completed}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="mybooking_task_empty">No tasks added</p>
                        ))}
                    </div>
                    {data.booking_status === "1" ? (
                      <div className="mybooking_assign">
                        <p className="mybooking_soon">
                          Admin will assign Companion soon.
                        </p>
                        <p
                          className="mybooking_help"
                          onClick={() => handlecancle(data.id)}
                        >
                          Cancel Booking
                        </p>
                      </div>
                    ) : data.booking_status === "2" ||
                      data.booking_status === "3" ||
                      data.booking_status === "4" ? (
                      <>
                        {" "}
                        <div className="mybooking_cardup">
                          <div className="mybooking_cardinfo">
                            <p>Companion Assigned</p>
                            <h3 className="mybooking_caretakerdata">
                              <img
                                src={`${process.env.REACT_APP_IMAGE_URL}${data.caregiver_pic}`}
                                alt="caregiver"
                                loading="lazy"
                              />
                              {data.caregiver_name}
                            </h3>
                          </div>
                          {/* <div className="mybooking_cardinfo">
                            <p>Country Code</p>
                            <h3>{getCaregiverCountryCode(data)}</h3>
                          </div> */}
                          <div className="mybooking_cardinfo">
                            <p>Phone Number</p>
                            <h3>{getCaregiverPhoneNumber(data)}</h3>
                          </div>
                        </div>
                        {data.help_status === "1" ? (
                          <p
                            className="mybooking_help"
                            onClick={() => handleneed(data.id)}
                          >
                            Need help?
                          </p>
                        ) : data.help_status === "2" ? (
                          <p className="mybooking_help">Help Requested</p>
                        ) : (
                          <p className="mybooking_help">Help Closed</p>
                        )}
                      </>
                    ) : data.booking_status === "5" ? (
                      <p className="mybooking_help">Booking Cancelled</p>
                    ) : (
                      <p className="mybooking_help">
                        Pending Cancellation Approval
                      </p>
                    )}
                  </div>
                ))}
              </div>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                getorderlist={getupcoming}
              />
            </div>
          ) : (
            <div className="blank_booking">No Upcoming Bookings</div>
          )}
        </div>
      </div>
      <Needhelp need={need} setneed={setneed} handleneedhelp={handleneedhelp} />
      <Canclebooking
        need={cancle}
        setneed={setcancle}
        handleneedhelp={handlecanclebooking}
      />
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={closealert}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert variant="filled" severity="success">
          {success}
        </Alert>
      </Snackbar>
      {load && <Loader />}
    </>
  );
};
export default Upcomingbook;
